import React, { Component } from 'react'
import { Button, Typography } from '@material-ui/core';
import View from 'react-flexbox'
import AddIcon from '@material-ui/icons/Add';
import { TabelaScorpion, ItemCustomRender, DialogPesquisa } from 'scorpion-core';
import CadastroItem from '../CadastroItem'



export default class Tabela extends Component {
    constructor(props) {
        super(props)
        this.updateItem = this.updateItem.bind(this)
        this.state = { editar: {} }

    }
    componentDidMount() {
        

    }
    updateItem(item) {
        

        const { input: { value, onChange } } = this.props
        let data = [];
        if (value) {
            data = value.slice();
        }
        const { index } = item;

        if (index != null) {

            data[index] = item;
        } else {
            data.push(item);

        }

        onChange(data)
    }

    getRenderCell(comp, item, indexArray) {
        const { customFormInterno, propsview } = this.props
        if (!comp.desativado) {
            let compExibir = getCompNoCuston(customFormInterno, comp.field);
            if (compExibir) {
                return <ItemCustomRender
                    item={{ ...compExibir, field: item.field + "." + indexArray + "." + comp.field, label: undefined }}
                    propsadd={{ style: {} }}
                    propsview={propsview}
                />
            }
        }

        return <ItemCustomRender
            item={{ ...comp, field: item.field + "." + indexArray + "." + comp.field, label: undefined }}
            propsadd={{ style: {} }}
            propsview={propsview}
        />
    }

    render() {
        const { item, input: { value, onChange },propsview } = this.props
        let mensagemVazio = "Sem Itens"
        let colunas = [];
        colunas.push({
            label: '...', getValue: (item2, index) =>
                <div>
                    {/* <Button onClick={() => this.startRemoverTalhao({ ...item, index })}>Remover</Button> */}
                    <Button variant="contained" color="primary" onClick={() => {


                        this.setState({ editar: { ...item2, index } },
                            this.dialog.show()
                        )

                    }}>Editar</Button>
                </div>
        });
        item.componentes.forEach((comp, index) => {
            colunas.push({
                ...comp, getValue: (itemArray, indexArray) => (
                    this.getRenderCell(comp, item, indexArray))
            })
        });


        let data = [];
        if (value) {
            data = value
        }

        return <View column>
            <View>
                <Typography variant="h6" >{item.label}</Typography>
                {item.customFormUid && <Button variant="contained" color="primary" onClick={() => {
                    this.setState({ editar: {} },
                        this.dialog.show()
                    )

                }}> <AddIcon />Adicionar</Button>}
            </View>
            <div >
                <TabelaScorpion colunas={colunas} mensagemVazio={mensagemVazio} data={data} />
            </div>
            <div>

                <DialogPesquisa forwardedRef={node => {
                    this.dialog = node
                }
                } >
                    <CadastroItem item={item} initialValues={this.state.editar}
                        salvar={(add) => { this.updateItem(add); this.dialog.hide() }}
                        sair={() => { this.dialog.hide() }} propsview={propsview} />

                </DialogPesquisa>

            </div>
        </View>

    }

}



export function getCompNoCuston(customForm, field) {
    return getCompNoCustom(customForm.componenteRoot.componentes, field);

}


export function getCompNoCustom(componentes, field) {
    let retorno = null;
    componentes.forEach(element => {
        // console.log('element',element);

        if (element.field === field) {
            retorno = element;
        }
        if (element.componentes && !retorno) {
            let r = getCompNoCustom(element.componentes, field)
            if (r) {
                retorno = r;
            }
        }
    });
    return retorno;
}



// WEBPACK FOOTER //
// ./src/routes/sistema/DinamicComponenets/components/TabelaItensCustomForm/Tabela/Tabela.js